import React, { Component } from "react";
import Predefine_2_Basketball from "../components/Predefine_2_Basketball/Predefine_2_Basketball";

export class Predefine_2_BasketballPage extends Component {
  render() {
    return <Predefine_2_Basketball />;
  }
}

export default Predefine_2_BasketballPage;
